// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Images/LandingImage/Rectangle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Images/image2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Images/image3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Images/image4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../Images/image5.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../Images/LandingImage/Second/Rectangle 12892.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../Images/venue.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@1,100;1,200&family=Inter:wght@100;200;400&family=Plus+Jakarta+Sans:wght@300&family=Roboto:ital,wght@1,100&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  * {
      font-family: 'Open Sans',
          /* font-family: 'Plus Jakarta Sans', sans-serif; */
  }


  .Header {
      background-color: #F1EDE7;
      height: 100px;
      color: #6E5240
  }

  .heading_color {
      color: #6E5240 !important;
      font-size: 15px;
  }

  .logo_design {
      font-weight: 600;
  }

  .squarecolor {
      background: #6E5240;
  }
/* 
  .logo-img-width {
      width: 21%;
      height: 13vh;
      cursor: pointer;
  } */

  .squarecolor_1 {
      background:
          #715948;
  }

  .squarecolor_2 {
      background: #836D5D;
  }

  .dot {
      height: 20px;
      width: 8px;
      display: inline-block;
      border: 0.25px solid wheat;
  }

  /* .show{
    width: 590px;
} */

  /* banner_1 */
  /* span.carousel-control-next-icon {
    display: none;
}
a.carousel-control-prev {
    display: none;
}
.carousel-indicators {
    display: none;
}
.carousel-caption {
    position: absolute;
    right: 0%;
    bottom: 1.25rem;
    left: 0%;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: center;
} */
  /* .Banner_1_container {
    height: 700px;
    color: #6E5240;
    box-sizing: border-box;
    position: relative; 
    
}


@keyframes changeBackground {
    0% { background-image: url("../../Images/LandingImage/Rectangle.png"); }
    50% { background-image: url("../../Images/new1.jpg"); }
    100% { background-image: url("../../Images/image2.jpg"); }
}


.Banner_1_container {
    animation: changeBackground 20s linear infinite;
} */
  .Banner_1_container {
      height: 600px;
      color: #6E5240;
      box-sizing: border-box;
      position: relative;
      /* Ensure relative positioning for absolute elements */
  }

  @keyframes changeBackground {
      0% {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      }

      20% {
          /* background-image: url("../../Images/mandap_yel.jpg"); */
      }

      40% {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
      }

      60% {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
      }

      80% {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
      }

      100% {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      }
  }

  /* Apply the animation to the container */
  .Banner_1_container {
      animation: changeBackground 30s linear infinite;

  }

  .select_container {
      background-color: #ffffff99;
      /* height: 95px; */

  }

  .Banner_1_Heading {
      font-weight: 600;
      color: #6E5240;

  }

  .Banner_1_Heading_2 {
      font-weight: 600;
      color: #6E5240;
      font-size: 40px;

  }

  .form-select-md {
      border: none;
  }

  .session {
      width: 36%;
      border-radius: 15px;

  }

  .budget-banner {
      margin-top: 10px;
      overflow: hidden;
      box-shadow: 0px 4px 4px #80808070;
      background: white;
      border-radius: 4px;
      transition: 0.2s all ease-in-out;
  }

  /* banner_2 */

  .Carousel-image {
      background-size: cover;
  }

  .Carousel-name {
      color: #6E5240;
      font-weight: 600;
  }

  .react-multi-carousel-dot-list {
      display: none !important;
  }

  .react-multiple-carousel__arrow--left {
      margin-left: -60px;
  }

  .react-multiple-carousel__arrow--right {
      margin-right: -50px;
  }


  /* banner5 */
  .col-image {
      background-size: cover;

  }

  .col-data {
      color: #836D5D;
      font-size: 16px;
      font-weight: 600;

  }

  .part4-subpart {
      height: 180px;

  }

  .iconpart4 {
      color: #715948;
      font-size: 25px;
  }

  .part4-column {
      border: 2px solid #836D5D;
      background-color: white;
  }

  /* next page */

  .button-group {
      background-color: #EEEEEE;
      color: #836D5D;
      border-radius: 8px;
      border: none;
  }

  .button-group:hover {
      background-color: #836D5D;
      color: #EEEEEE;
  }

  .clicked {
      background-color: #836D5D;
      color: #EEEEEE;
  }

  /* third */
  .galleryimage-1 {
      background-size: cover;
  }

  .galleryimage-2 {
      background-size: cover;
  }

  .galleryimage-3 {
      background-size: cover;
  }

  .galleryimage-4 {
      background-size: cover;
  }

  .galleryimage-5 {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
      background-size: cover;
  }

  .Details-data {
      font-weight: 600;
      font-size: 17px;
  }

  .header-btn {
      background-color: rgb(222 174 36);
      color: #fff;
      font-size: 15px;
      text-transform: none !important;
  }

  .header-btn:hover {
      background-color: rgb(222 174 36) !important;
      color: #fff;
  }

  .header-btn:focus {
      background-color: rgb(222 174 36) !important;
      color: #fff;
  }

  .contact-us {
      margin: 13px;
      font-weight: 600;
      font-size: 17px;
      text-decoration: none;
  }

  .location-drop {
      display: block;
      /* width: 100%; */
      padding: 0.5rem 1rem 0.5rem 0.75rem;
      -moz-padding-start: calc(.75rem - 3px);
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4rem;
      color: #495057;
      background-color: #f1ede7 !important;
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
      border: 1px solid #d2d6da;
      border-radius: 0.5rem;
      appearance: none;
      border: none;
  }

  .how-is-word {
      display: flex;
      height: 275px;
      /* justify-content: center; */
  }

  .image-div {
      display: flex;
      justify-content: center;
  }

  .image-div img {
      height: 60px;
      width: 60px;
  }

  .free-img {
      height: 80px;
      width: 88px;
      margin: 0 auto;
  }

  .howis-work-card {
      /* border-radius: 50%; */
      /* height: 35vh; */
      text-align: center;
      width: 400px;
      border-radius: 25px;
  }

  .howis-work-card {
      transition: transform 0.3s ease;
      /* Add smooth transition effect */
  }

  .howis-work-card:hover {
      transform: scale(1.05);
      /* Increase size on hover */
  }

  /* Optionally, you can add box shadow for a lift effect */
  .howis-work-card:hover {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
      /* Add box shadow on hover */
  }

  /* Optionally, you can change background color or add a border on hover */
  .howis-work-card:hover {
      background-color: #ffff;
      /* Change background color on hover */
  }

  .last-card {
      justify-content: center;
      display: flex;
      align-items: center;
      /* height: 28vh; */
      /* padding: 20px; */
  }

  .arrow-container {
      /* text-align: center;
      margin-top: 68px;
      margin-left: 5px; */
      display: flex;
      margin: 0;
  }

  svg.svg-inline--fa.fa-right-long {
      font-size: 30px;
  }

  .star-img {
      height: 30vh;
  }

  /* //banner3 css*/
  .banner-3 {
      width: fit-content;

      margin: 0px 10px;
      /* animation: marquee 20s infinite linear; */
  }

  li.react-multi-carousel-item.react-multi-carousel-item--active {
      width: auto !important;
  }



  .footer-links {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #5F5B59;
  }

  .move-card {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
  }
  /* .move-card {
      display: flex;
  } */

  .banner2-moveing {
      animation: marquee 20s infinite linear;
  }

  .card {
      border: none;
  }

  @keyframes marquee {
      0% {
          margin-left: 100%;
          /* Start position: move to the right edge of the container */
      }

      100% {
          margin-left: -100%;
          /* End position: move to the left edge of the container */
      }
  }

  /* banner5 */
  .talk {
      background: linear-gradient(133.64deg, #F3E9F3 2.03%, #E8D2E6 99.44%);
      margin-top: 1px;
  }

  .padb-20 {
      padding-bottom: 20px;
      padding-top: 35px;
      height: 100px;
  }

  a.red,
  .red {
      color: red;
  }

  /* .slideshow {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .slideshow img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    animation-duration: 6s; 
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }
  
  @keyframes fade {
    0%, 25% {
      opacity: 1;
    }
    50%, 75% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  .slideshow img.current {
    animation-name: fade;
  } */


  /* .contact-us */
  .contact-us-head {
      text-align: center;

  }

  .contact-label label {
      font-size: 16px;
  }

  .contact-btn {
      align-items: center;
      justify-content: center;
      display: flex;
  }

  .contact-btn button {
      border: none;
      margin-top: 20px;
      width: fit-content;
      padding: 10px 20px;
      border-radius: 5px;
  }

  .contact-sub-head {
      font-weight: 700;
      font-size: 17px;
  }

  .contact-footer {
      padding: 0px !important;
  }

  .about-us-para {
      text-align: justify;
      font-size: 15px;
  }

  .venuelink {
      color: #eb3a3a;
      cursor: pointer;
      margin-left: 5px;
      font-size: 16px;
  }

  .venue-image {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
      height: 325px;
      background-size: cover;
      width: 100%;

  }

  /* advanced page css */
  .budget-slider {
      width: 80%;
      margin: 20px auto;
  }

  .slider {
      -webkit-appearance: none;
      width: 100%;
      height: 25px;
      background: #d3d3d3;
      outline: none;
      opacity: 0.7;
      transition: opacity .2s;
  }

  .slider:hover {
      opacity: 1;
  }

  .slider::-webkit-slider-thumb {
      appearance: none;
      width: 25px;
      height: 25px;
      background: #4CAF50;
      cursor: pointer;
  }

  .slider::-moz-range-thumb {
      width: 25px;
      height: 25px;
      background: #4CAF50;
      cursor: pointer;
  }

  .graph {
      width: 80%;
      margin: 20px auto;
  }

  .bar {
      width: 0%;
      height: 25px;
      background-color: #4CAF50;
  }

  .advanced-img {
      width: 100%;
      height: 40vh;
  }

  .hall-amount {
      font-weight: 700;
      color: #000000;
      font-size: 20px;
      margin-left: 5px;
  }

  .hall-amount span {
      font-size: 12px;
      font-weight: 500;
  }

  .locality-border {
      border: 1px solid #00132514;
      border-radius: 4px;
      padding: 0px 10px;
      margin-bottom: 10px;
  }

  .locality-border li {
      list-style-type: none;
      display: flex;
      box-sizing: content-box;
      position: relative;
      cursor: pointer;
      font-size: 15px;
      font-weight: 700;
      color: var(--light);
      padding: 8px 12px;
      border-radius: 4px;
  }

  .Guests {
      display: flex;
      /* Use flexbox */
      justify-content: space-between;
      /* Space items evenly */
      align-items: center;
  }

  .Guests p {
      margin-top: 9px;
      float: right;
      font-size: 14px;
      cursor: pointer;
  }


  .radio-container input[type="radio"]+label {
      position: relative;
      /* padding-left: 20px; */
      cursor: pointer;
      font-size: 15px;
      -webkit-user-select: none;
      user-select: none;
  }

  .checkbox-container input[type="checkbox"]+label {
      position: relative;
      /* padding-left: 13px; */
      cursor: pointer;
      font-size: 15px;
      -webkit-user-select: none;
      user-select: none;
  }

  .sidebar-apply {
      /* align-items: center;
    justify-content: center;
    display: flex; */
      position: fixed;
      bottom: 25px;
      width: 21%;
      left: 22px;

  }

  .sidebar-apply button {
      font-weight: bold;
      display: inline-flex;
      /* width: 90%; */
      align-items: center;
      justify-content: center;
      line-height: 44px;
      min-height: 44px;
      max-height: 44px;
      white-space: nowrap;
      font-size: 17px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
      border: none;
      padding-left: 16px;
      padding-right: 16px;
      transition: 0.2s all;
  }

  .sidebar-img {
      height: 10vh;
      cursor: pointer;
      width:20vw;
  }

  .range-silder {
      width: 100%;
  }

  .range-slider-img {
      background: bisque;
      width: 100%;
      height: 50px;
  }



  .range-slider-container {
      width: 80%;
      margin: 20px auto;
  }

  .graph {
      width: 100%;
      height: 200px;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
  }

  .bar {
      width: 0;
      height: 100%;
      background-color: #007bff;
  }

  /* Define keyframes for the scroll animation */
  @keyframes scroll {
      0% {
          transform: translateX(0);
      }

      100% {
          transform: translateX(calc(-250px * 14));
      }

      /* Adjusted to match the number of slides */
  }

  /* Define animation speed variable */
  :root {
      --animation-speed: 50s;
  }

  /* Define white gradient mixin */
  @mixin white-gradient {
      background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  }

  /* Apply styles to the slider */
  /* .slider-banner3 {
       background: white;
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);
    height: 100px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: 960px;  */


  /* Apply white gradient to before and after pseudo-elements */
  &::before,
  &::after {
      @include white-gradient;
      content: "";
      height: 100px;
      position: absolute;
      width: 200px;
      z-index: 2;
  }

  /* Style the after pseudo-element */
  &::after {
      right: 0;
      top: 0;
      transform: rotateZ(180deg);
  }

  /* Style the before pseudo-element */
  &::before {
      left: 0;
      top: 0;
  }



  /* Apply animation to the slide track */
  .slide-track {
      animation: scroll var(--animation-speed) linear infinite;
      display: flex;
      width: calc(135px* 3);
  }



  /* Apply footer css here*/
  .footer_css {
      font-size: 15px;
      font-family: Lato, sans-serif;
      color: #34322E;
      font-weight: 700;
      /* line-height: 2px; */
      margin: 0px;
      padding: 0px;
      display: inline-block;




  }

  .footer_links {

      font-size: 13px;
      font-family: Lato, sans-serif;
      color: #5F5B59;
      font-weight: 400;
      line-height: 23px;
      padding: 1rem;
      /* Adjust padding as needed */
      vertical-align: middle;

  }

  a {


      text-decoration: none;
  }

  .foot-img {

      height: auto;
      width: auto;
      vertical-align: middle;
      margin-right: 5px;


  }


  .footer_head {
      color: #404040;

      font-size: 17px;
      font-family: sans-serif;
      font-weight: 700;


  }

  @media only screen and (max-width: 468px) {
      .arrow-container {
          display: none;
      }
  }

  @media only screen and (max-width: 468px) {
      .free-card {
          width: 100%;
      }

      .logo-img-width {
          width: 44% !important;
          height: 8vh;
          cursor: pointer;
      }

      .logo-img-width1 {
          width: 44% !important;
          height: 8vh;
          cursor: pointer;
      }
  }

  .navbar-brand img {
      width: 175px;
      height: auto;
  }

  .logo-img-width1 {
      width: 15%;
      height: 8vh;
      cursor: pointer;
  }

  .venue-top {
      margin-top: 130px;
  }

  .Search-hide {
      display: none !important;
  }

  .input-range__label--max .input-range__label-container {
      display: none;
  }

  .input-range__label--min {
      display: none;
  }

  .input-range {
      height: 1rem;
      position: relative;
      width: 91% !important;
      margin: 30px 10px;
  }


  .slides {


      /* height: 150px !important; */
  }

  img.products-image {
      width: 100%;
      height: 16%;
      color: grey;
      margin: auto !important;

  }

  .h-50 {
    height: 79% !important;
}

.venu_css{

font-weight: 600;
font-size: 28px;
color:#6e5240;

}



@media (max-width: 768px) {
    /* .mobile_card {
        margin-top: 350px !important;
    } */
    
    .filter_page_top{
        margin-top: 80px;
    }
    
    
  }
  
  @media (max-width: 480px) {
    .mobile_card {
        margin-top: 375px !important;
    }
    
    .filter_page_top{
        margin-top: 80px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/View/LandingPage/Style.css"],"names":[],"mappings":"EAEE;MACI,wBAAwB;UACpB,kDAAkD;EAC1D;;;EAGA;MACI,yBAAyB;MACzB,aAAa;MACb;EACJ;;EAEA;MACI,yBAAyB;MACzB,eAAe;EACnB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;EACvB;AACF;;;;;KAKK;;EAEH;MACI;iBACW;EACf;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,YAAY;MACZ,UAAU;MACV,qBAAqB;MACrB,0BAA0B;EAC9B;;EAEA;;GAEC;;EAED,aAAa;EACb;;;;;;;;;;;;;;;;;;GAkBC;EACD;;;;;;;;;;;;;;;;;;GAkBC;EACD;MACI,aAAa;MACb,cAAc;MACd,sBAAsB;MACtB,kBAAkB;MAClB,sDAAsD;EAC1D;;EAEA;MACI;UACI,yDAAgE;MACpE;;MAEA;UACI,0DAA0D;MAC9D;;MAEA;UACI,yDAAgD;MACpD;;MAEA;UACI,yDAAgD;MACpD;;MAEA;UACI,yDAAgD;MACpD;;MAEA;UACI,yDAAgD;MACpD;EACJ;;EAEA,yCAAyC;EACzC;MACI,+CAA+C;;EAEnD;;EAEA;MACI,2BAA2B;MAC3B,kBAAkB;;EAEtB;;EAEA;MACI,gBAAgB;MAChB,cAAc;;EAElB;;EAEA;MACI,gBAAgB;MAChB,cAAc;MACd,eAAe;;EAEnB;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI,UAAU;MACV,mBAAmB;;EAEvB;;EAEA;MACI,gBAAgB;MAChB,gBAAgB;MAChB,iCAAiC;MACjC,iBAAiB;MACjB,kBAAkB;MAClB,gCAAgC;EACpC;;EAEA,aAAa;;EAEb;MACI,sBAAsB;EAC1B;;EAEA;MACI,cAAc;MACd,gBAAgB;EACpB;;EAEA;MACI,wBAAwB;EAC5B;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,mBAAmB;EACvB;;;EAGA,YAAY;EACZ;MACI,sBAAsB;;EAE1B;;EAEA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;;EAEpB;;EAEA;MACI,aAAa;;EAEjB;;EAEA;MACI,cAAc;MACd,eAAe;EACnB;;EAEA;MACI,yBAAyB;MACzB,uBAAuB;EAC3B;;EAEA,cAAc;;EAEd;MACI,yBAAyB;MACzB,cAAc;MACd,kBAAkB;MAClB,YAAY;EAChB;;EAEA;MACI,yBAAyB;MACzB,cAAc;EAClB;;EAEA;MACI,yBAAyB;MACzB,cAAc;EAClB;;EAEA,UAAU;EACV;MACI,sBAAsB;EAC1B;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,yDAA8E;MAC9E,sBAAsB;EAC1B;;EAEA;MACI,gBAAgB;MAChB,eAAe;EACnB;;EAEA;MACI,iCAAiC;MACjC,WAAW;MACX,eAAe;MACf,+BAA+B;EACnC;;EAEA;MACI,4CAA4C;MAC5C,WAAW;EACf;;EAEA;MACI,4CAA4C;MAC5C,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,qBAAqB;EACzB;;EAEA;MACI,cAAc;MACd,iBAAiB;MACjB,mCAAmC;MACnC,sCAAsC;MACtC,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;MACd,oCAAoC;MACpC,4BAA4B;MAC5B,yCAAyC;MACzC,0BAA0B;MAC1B,yBAAyB;MACzB,qBAAqB;MACrB,gBAAgB;MAChB,YAAY;EAChB;;EAEA;MACI,aAAa;MACb,aAAa;MACb,6BAA6B;EACjC;;EAEA;MACI,aAAa;MACb,uBAAuB;EAC3B;;EAEA;MACI,YAAY;MACZ,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,WAAW;MACX,cAAc;EAClB;;EAEA;MACI,wBAAwB;MACxB,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;EACvB;;EAEA;MACI,+BAA+B;MAC/B,iCAAiC;EACrC;;EAEA;MACI,sBAAsB;MACtB,2BAA2B;EAC/B;;EAEA,yDAAyD;EACzD;MACI,2CAA2C;MAC3C,4BAA4B;EAChC;;EAEA,yEAAyE;EACzE;MACI,uBAAuB;MACvB,qCAAqC;EACzC;;EAEA;MACI,uBAAuB;MACvB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA;MACI;;yBAEmB;MACnB,aAAa;MACb,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,YAAY;EAChB;;EAEA,iBAAiB;EACjB;MACI,kBAAkB;;MAElB,gBAAgB;MAChB,4CAA4C;EAChD;;EAEA;MACI,sBAAsB;EAC1B;;;;EAIA;MACI,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;;KAEG;;EAEH;MACI,sCAAsC;EAC1C;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI;UACI,iBAAiB;UACjB,4DAA4D;MAChE;;MAEA;UACI,kBAAkB;UAClB,yDAAyD;MAC7D;EACJ;;EAEA,YAAY;EACZ;MACI,qEAAqE;MACrE,eAAe;EACnB;;EAEA;MACI,oBAAoB;MACpB,iBAAiB;MACjB,aAAa;EACjB;;EAEA;;MAEI,UAAU;EACd;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAgCG;;;EAGH,gBAAgB;EAChB;MACI,kBAAkB;;EAEtB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,mBAAmB;MACnB,uBAAuB;MACvB,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,kBAAkB;EACtB;;EAEA;MACI,gBAAgB;MAChB,eAAe;EACnB;;EAEA;MACI,uBAAuB;EAC3B;;EAEA;MACI,mBAAmB;MACnB,eAAe;EACnB;;EAEA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,eAAe;EACnB;;EAEA;MACI,yDAA+C;MAC/C,aAAa;MACb,sBAAsB;MACtB,WAAW;;EAEf;;EAEA,sBAAsB;EACtB;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;MACI,wBAAwB;MACxB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,aAAa;MACb,YAAY;MAEZ,uBAAuB;EAC3B;;EAEA;MACI,UAAU;EACd;;EAEA;MAEI,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,eAAe;EACnB;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;MACI,SAAS;MACT,YAAY;MACZ,yBAAyB;EAC7B;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,gBAAgB;MAChB,cAAc;MACd,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,2BAA2B;MAC3B,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB;EACvB;;EAEA;MACI,qBAAqB;MACrB,aAAa;MACb,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,kBAAkB;EACtB;;EAEA;MACI,aAAa;MACb,gBAAgB;MAChB,8BAA8B;MAC9B,uBAAuB;MACvB,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,YAAY;MACZ,eAAe;MACf,eAAe;EACnB;;;EAGA;MACI,kBAAkB;MAClB,wBAAwB;MACxB,eAAe;MACf,eAAe;MACf,yBAAyB;MAGzB,iBAAiB;EACrB;;EAEA;MACI,kBAAkB;MAClB,wBAAwB;MACxB,eAAe;MACf,eAAe;MACf,yBAAyB;MAGzB,iBAAiB;EACrB;;EAEA;MACI;;oBAEc;MACd,eAAe;MACf,YAAY;MACZ,UAAU;MACV,UAAU;;EAEd;;EAEA;MACI,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;EACxB;;EAEA;MACI,YAAY;MACZ,eAAe;MACf,UAAU;EACd;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,kBAAkB;MAClB,WAAW;MACX,YAAY;EAChB;;;;EAIA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;MACI,WAAW;MACX,aAAa;MACb,yBAAyB;MACzB,sBAAsB;EAC1B;;EAEA;MACI,QAAQ;MACR,YAAY;MACZ,yBAAyB;EAC7B;;EAEA,8CAA8C;EAC9C;MACI;UACI,wBAAwB;MAC5B;;MAEA;UACI,wCAAwC;MAC5C;;MAEA,2CAA2C;EAC/C;;EAEA,oCAAoC;EACpC;MACI,sBAAsB;EAC1B;;EAEA,gCAAgC;EAChC;MACI,6FAA6F;EACjG;;EAEA,+BAA+B;EAC/B;;;;;;;oBAOkB;;;EAGlB,6DAA6D;EAC7D;;MAEI,uBAAuB;MACvB,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,UAAU;EACd;;EAEA,mCAAmC;EACnC;MACI,QAAQ;MACR,MAAM;MACN,0BAA0B;EAC9B;;EAEA,oCAAoC;EACpC;MACI,OAAO;MACP,MAAM;EACV;;;;EAIA,uCAAuC;EACvC;MACI,wDAAwD;MACxD,aAAa;MACb,qBAAqB;EACzB;;;;EAIA,yBAAyB;EACzB;MACI,eAAe;MACf,6BAA6B;MAC7B,cAAc;MACd,gBAAgB;MAChB,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,qBAAqB;;;;;EAKzB;;EAEA;;MAEI,eAAe;MACf,6BAA6B;MAC7B,cAAc;MACd,gBAAgB;MAChB,iBAAiB;MACjB,aAAa;MACb,6BAA6B;MAC7B,sBAAsB;;EAE1B;;EAEA;;;MAGI,qBAAqB;EACzB;;EAEA;;MAEI,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,iBAAiB;;;EAGrB;;;EAGA;MACI,cAAc;;MAEd,eAAe;MACf,uBAAuB;MACvB,gBAAgB;;;EAGpB;;EAEA;MACI;UACI,aAAa;MACjB;EACJ;;EAEA;MACI;UACI,WAAW;MACf;;MAEA;UACI,qBAAqB;UACrB,WAAW;UACX,eAAe;MACnB;;MAEA;UACI,qBAAqB;UACrB,WAAW;UACX,eAAe;MACnB;EACJ;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;MACI,UAAU;MACV,WAAW;MACX,eAAe;EACnB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,wBAAwB;EAC5B;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,kBAAkB;MAClB,qBAAqB;MACrB,iBAAiB;EACrB;;;EAGA;;;MAGI,8BAA8B;EAClC;;EAEA;MACI,WAAW;MACX,WAAW;MACX,WAAW;MACX,uBAAuB;;EAE3B;;EAEA;IACE,sBAAsB;AAC1B;;AAEA;;AAEA,gBAAgB;AAChB,eAAe;AACf,aAAa;;AAEb;;;;AAIA;IACI;;OAEG;;IAEH;QACI,gBAAgB;IACpB;;;EAGF;;EAEA;IACE;QACI,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;EACF","sourcesContent":["  @import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@1,100;1,200&family=Inter:wght@100;200;400&family=Plus+Jakarta+Sans:wght@300&family=Roboto:ital,wght@1,100&display=swap');\n\n  * {\n      font-family: 'Open Sans',\n          /* font-family: 'Plus Jakarta Sans', sans-serif; */\n  }\n\n\n  .Header {\n      background-color: #F1EDE7;\n      height: 100px;\n      color: #6E5240\n  }\n\n  .heading_color {\n      color: #6E5240 !important;\n      font-size: 15px;\n  }\n\n  .logo_design {\n      font-weight: 600;\n  }\n\n  .squarecolor {\n      background: #6E5240;\n  }\n/* \n  .logo-img-width {\n      width: 21%;\n      height: 13vh;\n      cursor: pointer;\n  } */\n\n  .squarecolor_1 {\n      background:\n          #715948;\n  }\n\n  .squarecolor_2 {\n      background: #836D5D;\n  }\n\n  .dot {\n      height: 20px;\n      width: 8px;\n      display: inline-block;\n      border: 0.25px solid wheat;\n  }\n\n  /* .show{\n    width: 590px;\n} */\n\n  /* banner_1 */\n  /* span.carousel-control-next-icon {\n    display: none;\n}\na.carousel-control-prev {\n    display: none;\n}\n.carousel-indicators {\n    display: none;\n}\n.carousel-caption {\n    position: absolute;\n    right: 0%;\n    bottom: 1.25rem;\n    left: 0%;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    color: #fff;\n    text-align: center;\n} */\n  /* .Banner_1_container {\n    height: 700px;\n    color: #6E5240;\n    box-sizing: border-box;\n    position: relative; \n    \n}\n\n\n@keyframes changeBackground {\n    0% { background-image: url(\"../../Images/LandingImage/Rectangle.png\"); }\n    50% { background-image: url(\"../../Images/new1.jpg\"); }\n    100% { background-image: url(\"../../Images/image2.jpg\"); }\n}\n\n\n.Banner_1_container {\n    animation: changeBackground 20s linear infinite;\n} */\n  .Banner_1_container {\n      height: 600px;\n      color: #6E5240;\n      box-sizing: border-box;\n      position: relative;\n      /* Ensure relative positioning for absolute elements */\n  }\n\n  @keyframes changeBackground {\n      0% {\n          background-image: url(\"../../Images/LandingImage/Rectangle.png\");\n      }\n\n      20% {\n          /* background-image: url(\"../../Images/mandap_yel.jpg\"); */\n      }\n\n      40% {\n          background-image: url(\"../../Images/image2.jpg\");\n      }\n\n      60% {\n          background-image: url(\"../../Images/image3.jpg\");\n      }\n\n      80% {\n          background-image: url(\"../../Images/image4.jpg\");\n      }\n\n      100% {\n          background-image: url(\"../../Images/image5.jpg\");\n      }\n  }\n\n  /* Apply the animation to the container */\n  .Banner_1_container {\n      animation: changeBackground 30s linear infinite;\n\n  }\n\n  .select_container {\n      background-color: #ffffff99;\n      /* height: 95px; */\n\n  }\n\n  .Banner_1_Heading {\n      font-weight: 600;\n      color: #6E5240;\n\n  }\n\n  .Banner_1_Heading_2 {\n      font-weight: 600;\n      color: #6E5240;\n      font-size: 40px;\n\n  }\n\n  .form-select-md {\n      border: none;\n  }\n\n  .session {\n      width: 36%;\n      border-radius: 15px;\n\n  }\n\n  .budget-banner {\n      margin-top: 10px;\n      overflow: hidden;\n      box-shadow: 0px 4px 4px #80808070;\n      background: white;\n      border-radius: 4px;\n      transition: 0.2s all ease-in-out;\n  }\n\n  /* banner_2 */\n\n  .Carousel-image {\n      background-size: cover;\n  }\n\n  .Carousel-name {\n      color: #6E5240;\n      font-weight: 600;\n  }\n\n  .react-multi-carousel-dot-list {\n      display: none !important;\n  }\n\n  .react-multiple-carousel__arrow--left {\n      margin-left: -60px;\n  }\n\n  .react-multiple-carousel__arrow--right {\n      margin-right: -50px;\n  }\n\n\n  /* banner5 */\n  .col-image {\n      background-size: cover;\n\n  }\n\n  .col-data {\n      color: #836D5D;\n      font-size: 16px;\n      font-weight: 600;\n\n  }\n\n  .part4-subpart {\n      height: 180px;\n\n  }\n\n  .iconpart4 {\n      color: #715948;\n      font-size: 25px;\n  }\n\n  .part4-column {\n      border: 2px solid #836D5D;\n      background-color: white;\n  }\n\n  /* next page */\n\n  .button-group {\n      background-color: #EEEEEE;\n      color: #836D5D;\n      border-radius: 8px;\n      border: none;\n  }\n\n  .button-group:hover {\n      background-color: #836D5D;\n      color: #EEEEEE;\n  }\n\n  .clicked {\n      background-color: #836D5D;\n      color: #EEEEEE;\n  }\n\n  /* third */\n  .galleryimage-1 {\n      background-size: cover;\n  }\n\n  .galleryimage-2 {\n      background-size: cover;\n  }\n\n  .galleryimage-3 {\n      background-size: cover;\n  }\n\n  .galleryimage-4 {\n      background-size: cover;\n  }\n\n  .galleryimage-5 {\n      background-image: url(\"../../Images/LandingImage/Second/Rectangle\\ 12892.png\");\n      background-size: cover;\n  }\n\n  .Details-data {\n      font-weight: 600;\n      font-size: 17px;\n  }\n\n  .header-btn {\n      background-color: rgb(222 174 36);\n      color: #fff;\n      font-size: 15px;\n      text-transform: none !important;\n  }\n\n  .header-btn:hover {\n      background-color: rgb(222 174 36) !important;\n      color: #fff;\n  }\n\n  .header-btn:focus {\n      background-color: rgb(222 174 36) !important;\n      color: #fff;\n  }\n\n  .contact-us {\n      margin: 13px;\n      font-weight: 600;\n      font-size: 17px;\n      text-decoration: none;\n  }\n\n  .location-drop {\n      display: block;\n      /* width: 100%; */\n      padding: 0.5rem 1rem 0.5rem 0.75rem;\n      -moz-padding-start: calc(.75rem - 3px);\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.4rem;\n      color: #495057;\n      background-color: #f1ede7 !important;\n      background-repeat: no-repeat;\n      background-position: right 0.75rem center;\n      background-size: 16px 12px;\n      border: 1px solid #d2d6da;\n      border-radius: 0.5rem;\n      appearance: none;\n      border: none;\n  }\n\n  .how-is-word {\n      display: flex;\n      height: 275px;\n      /* justify-content: center; */\n  }\n\n  .image-div {\n      display: flex;\n      justify-content: center;\n  }\n\n  .image-div img {\n      height: 60px;\n      width: 60px;\n  }\n\n  .free-img {\n      height: 80px;\n      width: 88px;\n      margin: 0 auto;\n  }\n\n  .howis-work-card {\n      /* border-radius: 50%; */\n      /* height: 35vh; */\n      text-align: center;\n      width: 400px;\n      border-radius: 25px;\n  }\n\n  .howis-work-card {\n      transition: transform 0.3s ease;\n      /* Add smooth transition effect */\n  }\n\n  .howis-work-card:hover {\n      transform: scale(1.05);\n      /* Increase size on hover */\n  }\n\n  /* Optionally, you can add box shadow for a lift effect */\n  .howis-work-card:hover {\n      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n      /* Add box shadow on hover */\n  }\n\n  /* Optionally, you can change background color or add a border on hover */\n  .howis-work-card:hover {\n      background-color: #ffff;\n      /* Change background color on hover */\n  }\n\n  .last-card {\n      justify-content: center;\n      display: flex;\n      align-items: center;\n      /* height: 28vh; */\n      /* padding: 20px; */\n  }\n\n  .arrow-container {\n      /* text-align: center;\n      margin-top: 68px;\n      margin-left: 5px; */\n      display: flex;\n      margin: 0;\n  }\n\n  svg.svg-inline--fa.fa-right-long {\n      font-size: 30px;\n  }\n\n  .star-img {\n      height: 30vh;\n  }\n\n  /* //banner3 css*/\n  .banner-3 {\n      width: fit-content;\n\n      margin: 0px 10px;\n      /* animation: marquee 20s infinite linear; */\n  }\n\n  li.react-multi-carousel-item.react-multi-carousel-item--active {\n      width: auto !important;\n  }\n\n\n\n  .footer-links {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 16px;\n      color: #5F5B59;\n  }\n\n  .move-card {\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n    position: relative;\n  }\n  /* .move-card {\n      display: flex;\n  } */\n\n  .banner2-moveing {\n      animation: marquee 20s infinite linear;\n  }\n\n  .card {\n      border: none;\n  }\n\n  @keyframes marquee {\n      0% {\n          margin-left: 100%;\n          /* Start position: move to the right edge of the container */\n      }\n\n      100% {\n          margin-left: -100%;\n          /* End position: move to the left edge of the container */\n      }\n  }\n\n  /* banner5 */\n  .talk {\n      background: linear-gradient(133.64deg, #F3E9F3 2.03%, #E8D2E6 99.44%);\n      margin-top: 1px;\n  }\n\n  .padb-20 {\n      padding-bottom: 20px;\n      padding-top: 35px;\n      height: 100px;\n  }\n\n  a.red,\n  .red {\n      color: red;\n  }\n\n  /* .slideshow {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .slideshow img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    animation-duration: 6s; \n    animation-timing-function: ease-in-out;\n    animation-fill-mode: forwards;\n  }\n  \n  @keyframes fade {\n    0%, 25% {\n      opacity: 1;\n    }\n    50%, 75% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  \n  .slideshow img.current {\n    animation-name: fade;\n  } */\n\n\n  /* .contact-us */\n  .contact-us-head {\n      text-align: center;\n\n  }\n\n  .contact-label label {\n      font-size: 16px;\n  }\n\n  .contact-btn {\n      align-items: center;\n      justify-content: center;\n      display: flex;\n  }\n\n  .contact-btn button {\n      border: none;\n      margin-top: 20px;\n      width: fit-content;\n      padding: 10px 20px;\n      border-radius: 5px;\n  }\n\n  .contact-sub-head {\n      font-weight: 700;\n      font-size: 17px;\n  }\n\n  .contact-footer {\n      padding: 0px !important;\n  }\n\n  .about-us-para {\n      text-align: justify;\n      font-size: 15px;\n  }\n\n  .venuelink {\n      color: #eb3a3a;\n      cursor: pointer;\n      margin-left: 5px;\n      font-size: 16px;\n  }\n\n  .venue-image {\n      background-image: url(\"../../Images/venue.jpg\");\n      height: 325px;\n      background-size: cover;\n      width: 100%;\n\n  }\n\n  /* advanced page css */\n  .budget-slider {\n      width: 80%;\n      margin: 20px auto;\n  }\n\n  .slider {\n      -webkit-appearance: none;\n      width: 100%;\n      height: 25px;\n      background: #d3d3d3;\n      outline: none;\n      opacity: 0.7;\n      -webkit-transition: .2s;\n      transition: opacity .2s;\n  }\n\n  .slider:hover {\n      opacity: 1;\n  }\n\n  .slider::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 25px;\n      height: 25px;\n      background: #4CAF50;\n      cursor: pointer;\n  }\n\n  .slider::-moz-range-thumb {\n      width: 25px;\n      height: 25px;\n      background: #4CAF50;\n      cursor: pointer;\n  }\n\n  .graph {\n      width: 80%;\n      margin: 20px auto;\n  }\n\n  .bar {\n      width: 0%;\n      height: 25px;\n      background-color: #4CAF50;\n  }\n\n  .advanced-img {\n      width: 100%;\n      height: 40vh;\n  }\n\n  .hall-amount {\n      font-weight: 700;\n      color: #000000;\n      font-size: 20px;\n      margin-left: 5px;\n  }\n\n  .hall-amount span {\n      font-size: 12px;\n      font-weight: 500;\n  }\n\n  .locality-border {\n      border: 1px solid #00132514;\n      border-radius: 4px;\n      padding: 0px 10px;\n      margin-bottom: 10px;\n  }\n\n  .locality-border li {\n      list-style-type: none;\n      display: flex;\n      box-sizing: content-box;\n      position: relative;\n      cursor: pointer;\n      font-size: 15px;\n      font-weight: 700;\n      color: var(--light);\n      padding: 8px 12px;\n      border-radius: 4px;\n  }\n\n  .Guests {\n      display: flex;\n      /* Use flexbox */\n      justify-content: space-between;\n      /* Space items evenly */\n      align-items: center;\n  }\n\n  .Guests p {\n      margin-top: 9px;\n      float: right;\n      font-size: 14px;\n      cursor: pointer;\n  }\n\n\n  .radio-container input[type=\"radio\"]+label {\n      position: relative;\n      /* padding-left: 20px; */\n      cursor: pointer;\n      font-size: 15px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n  }\n\n  .checkbox-container input[type=\"checkbox\"]+label {\n      position: relative;\n      /* padding-left: 13px; */\n      cursor: pointer;\n      font-size: 15px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n  }\n\n  .sidebar-apply {\n      /* align-items: center;\n    justify-content: center;\n    display: flex; */\n      position: fixed;\n      bottom: 25px;\n      width: 21%;\n      left: 22px;\n\n  }\n\n  .sidebar-apply button {\n      font-weight: bold;\n      display: inline-flex;\n      /* width: 90%; */\n      align-items: center;\n      justify-content: center;\n      line-height: 44px;\n      min-height: 44px;\n      max-height: 44px;\n      white-space: nowrap;\n      font-size: 17px;\n      text-align: center;\n      border-radius: 5px;\n      cursor: pointer;\n      border: none;\n      padding-left: 16px;\n      padding-right: 16px;\n      transition: 0.2s all;\n  }\n\n  .sidebar-img {\n      height: 10vh;\n      cursor: pointer;\n      width:20vw;\n  }\n\n  .range-silder {\n      width: 100%;\n  }\n\n  .range-slider-img {\n      background: bisque;\n      width: 100%;\n      height: 50px;\n  }\n\n\n\n  .range-slider-container {\n      width: 80%;\n      margin: 20px auto;\n  }\n\n  .graph {\n      width: 100%;\n      height: 200px;\n      background-color: #f0f0f0;\n      border: 1px solid #ccc;\n  }\n\n  .bar {\n      width: 0;\n      height: 100%;\n      background-color: #007bff;\n  }\n\n  /* Define keyframes for the scroll animation */\n  @keyframes scroll {\n      0% {\n          transform: translateX(0);\n      }\n\n      100% {\n          transform: translateX(calc(-250px * 14));\n      }\n\n      /* Adjusted to match the number of slides */\n  }\n\n  /* Define animation speed variable */\n  :root {\n      --animation-speed: 50s;\n  }\n\n  /* Define white gradient mixin */\n  @mixin white-gradient {\n      background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);\n  }\n\n  /* Apply styles to the slider */\n  /* .slider-banner3 {\n       background: white;\n    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);\n    height: 100px;\n    margin: auto;\n    overflow: hidden;\n    position: relative;\n    width: 960px;  */\n\n\n  /* Apply white gradient to before and after pseudo-elements */\n  &::before,\n  &::after {\n      @include white-gradient;\n      content: \"\";\n      height: 100px;\n      position: absolute;\n      width: 200px;\n      z-index: 2;\n  }\n\n  /* Style the after pseudo-element */\n  &::after {\n      right: 0;\n      top: 0;\n      transform: rotateZ(180deg);\n  }\n\n  /* Style the before pseudo-element */\n  &::before {\n      left: 0;\n      top: 0;\n  }\n\n\n\n  /* Apply animation to the slide track */\n  .slide-track {\n      animation: scroll var(--animation-speed) linear infinite;\n      display: flex;\n      width: calc(135px* 3);\n  }\n\n\n\n  /* Apply footer css here*/\n  .footer_css {\n      font-size: 15px;\n      font-family: Lato, sans-serif;\n      color: #34322E;\n      font-weight: 700;\n      /* line-height: 2px; */\n      margin: 0px;\n      padding: 0px;\n      display: inline-block;\n\n\n\n\n  }\n\n  .footer_links {\n\n      font-size: 13px;\n      font-family: Lato, sans-serif;\n      color: #5F5B59;\n      font-weight: 400;\n      line-height: 23px;\n      padding: 1rem;\n      /* Adjust padding as needed */\n      vertical-align: middle;\n\n  }\n\n  a {\n\n\n      text-decoration: none;\n  }\n\n  .foot-img {\n\n      height: auto;\n      width: auto;\n      vertical-align: middle;\n      margin-right: 5px;\n\n\n  }\n\n\n  .footer_head {\n      color: #404040;\n\n      font-size: 17px;\n      font-family: sans-serif;\n      font-weight: 700;\n\n\n  }\n\n  @media only screen and (max-width: 468px) {\n      .arrow-container {\n          display: none;\n      }\n  }\n\n  @media only screen and (max-width: 468px) {\n      .free-card {\n          width: 100%;\n      }\n\n      .logo-img-width {\n          width: 44% !important;\n          height: 8vh;\n          cursor: pointer;\n      }\n\n      .logo-img-width1 {\n          width: 44% !important;\n          height: 8vh;\n          cursor: pointer;\n      }\n  }\n\n  .navbar-brand img {\n      width: 175px;\n      height: auto;\n  }\n\n  .logo-img-width1 {\n      width: 15%;\n      height: 8vh;\n      cursor: pointer;\n  }\n\n  .venue-top {\n      margin-top: 130px;\n  }\n\n  .Search-hide {\n      display: none !important;\n  }\n\n  .input-range__label--max .input-range__label-container {\n      display: none;\n  }\n\n  .input-range__label--min {\n      display: none;\n  }\n\n  .input-range {\n      height: 1rem;\n      position: relative;\n      width: 91% !important;\n      margin: 30px 10px;\n  }\n\n\n  .slides {\n\n\n      /* height: 150px !important; */\n  }\n\n  img.products-image {\n      width: 100%;\n      height: 16%;\n      color: grey;\n      margin: auto !important;\n\n  }\n\n  .h-50 {\n    height: 79% !important;\n}\n\n.venu_css{\n\nfont-weight: 600;\nfont-size: 28px;\ncolor:#6e5240;\n\n}\n\n\n\n@media (max-width: 768px) {\n    /* .mobile_card {\n        margin-top: 350px !important;\n    } */\n    \n    .filter_page_top{\n        margin-top: 80px;\n    }\n    \n    \n  }\n  \n  @media (max-width: 480px) {\n    .mobile_card {\n        margin-top: 375px !important;\n    }\n    \n    .filter_page_top{\n        margin-top: 80px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
